import { useState } from 'react';
import { useToast } from "@/hooks/use-toast";
import { verifyEmail, resendVerificationEmail } from './services/verificationService';

export const useEmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const confirmEmail = async (verificationToken: string): Promise<boolean> => {
    setIsLoading(true);

    const result = await verifyEmail(verificationToken);

    if (result.success) {
      toast({
        title: "E-mail megerősítve",
        description: result.message,
      });
    } else {
      toast({
        title: "Megerősítési hiba",
        description: result.message,
        variant: "destructive",
      });
    }

    setIsLoading(false);
    return result.success;
  };

  const resendVerification = async (email: string): Promise<boolean> => {
    setIsLoading(true);

    const result = await resendVerificationEmail(email);

    if (result.success) {
      toast({
        title: "E-mail elküldve",
        description: result.message,
      });
    } else {
      toast({
        title: "Küldési hiba",
        description: result.message,
        variant: "destructive",
      });
    }

    setIsLoading(false);
    return result.success;
  };

  return { confirmEmail, resendVerification, isLoading };
};
